class CollectionMetalFilter extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.filterParamName = this.dataset.filterParamName;
    this.addEventListener("click", this.#onChipClick, true);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.#onChipClick, true);
  }

  #buildSingleSelectUrl(link) {
    const url = new URL(window.location.href);
    const paramName = link.dataset.filterParam || this.filterParamName;
    const paramValue = link.dataset.filterValue;

    if (paramName && paramValue) {
      url.searchParams.delete(paramName);
      url.searchParams.set(paramName, paramValue);
    } else {
      const filterTarget = new URL(link.getAttribute("href"), window.location.href);

      if (paramName) {
        url.searchParams.delete(paramName);

        const paramValues = filterTarget.searchParams.getAll(paramName);
        const nextValue = paramValues.at(-1);

        if (nextValue) {
          url.searchParams.set(paramName, nextValue);
        }
      } else {
        url.search = filterTarget.search;
      }
    }

    url.searchParams.delete("metall");
    url.searchParams.delete("metal");
    url.searchParams.delete("page");

    return url;
  }

  #onChipClick(event) {
    const link = event.target.closest(".collection-metal-filter__link a");
    if (!link || !this.contains(link)) return;

    event.preventDefault();
    event.stopPropagation();

    const url = this.#buildSingleSelectUrl(link);
    url.searchParams.set("section_id", this.sectionId);

    this.#setCollectionLoading(true);
    document.documentElement.addEventListener("theme:loading:end", () => this.#setCollectionLoading(false), {
      once: true
    });

    this.dispatchEvent(
      new CustomEvent("facet:update", {
        bubbles: true,
        detail: {
          url,
          preventScroll: true
        }
      })
    );
  }

  #setCollectionLoading(isLoading) {
    const main = this.closest(".shopify-section")?.querySelector(".collection__main");
    if (main) {
      main.classList.toggle("collection__main--metal-loading", isLoading);
    }
  }
}

if (!window.customElements.get("collection-metal-filter")) {
  window.customElements.define("collection-metal-filter", CollectionMetalFilter);
}
